// What the shell exposes as `window.TwFileStore` (see `FileStoreBridge.kt`): a file the page has built, written
// where the user can find it afterwards - the device's Download folder

interface FileStoreBridge {
  saveToDownloads(fileName: string, base64: string): string;
}

function fileStore(): FileStoreBridge | undefined {
  return typeof window === 'undefined' ? undefined : (window as any).TwFileStore;
}

const blobToBase64 = async (blob: Blob): Promise<string> => {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = '';

  // In chunks: `String.fromCharCode(...bytes)` on a file of several hundred KB overflows the argument limit
  for (let index = 0; index < bytes.length; index += 0x8000) {
    binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(index, index + 0x8000)));
  }

  return btoa(binary);
};

/**
 * Writes the file into the device's Download folder. Answers the name it was saved under, or `null` when the shell
 * is not there (a browser) or refused the write, which is the caller's cue to hand the file over itself.
 */
export async function saveFileToDownloads(fileName: string, blob: Blob): Promise<string | null> {
  const bridge = fileStore();

  if (!bridge?.saveToDownloads) {
    return null;
  }

  try {
    const base64 = await blobToBase64(blob);

    return bridge.saveToDownloads(fileName, base64) || null;
  } catch (error) {
    console.warn('the app could not save the file on the device', { fileName, error });
    return null;
  }
}
